export default __webpack_public_path__ + "static/media/june_2025_1.5e4903a9.jpeg";